module.exports = __webpack_public_path__ + "static/media/user.d04f8ae1.svg";